import { render, staticRenderFns } from "./PricingChart.vue?vue&type=template&id=47f0ac25&scoped=true&"
import script from "./PricingChart.vue?vue&type=script&lang=js&"
export * from "./PricingChart.vue?vue&type=script&lang=js&"
import style0 from "./PricingChart.vue?vue&type=style&index=0&id=47f0ac25&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47f0ac25",
  null
  
)

export default component.exports